import React from 'react';
import Select from '../commons/Select.jsx'
import Helper from "../../../model/Helper";
import RadioGroup from '../commons/RadioGroup.jsx'
import SidebarFrame from "./SidebarFrame";

export default class BodenSettings extends SidebarFrame {

    state = {
        bodenFactory: this.vsData.spreadEquallyOverFreeSpaceY(),
        products: APP.findProductsByType('Einlegeboden')
    }

    get vsData() {
        return this.props.model.vsData;
    }

    getSidebarParent() {
        return "einbauten";
    }

    renderTitle() {
        return I18N("Einlegeboden");
    }

    anzahlChanged(anzahl) {
        let choiceCount = this.vsData.element.hasEinlegeboden(this.props.model)
            ? 1
            : parseInt(anzahl, 10);
        const anzahlInt = parseInt(anzahl, 10);
        this.state.bodenFactory.create(anzahlInt);
        this.vsData.faecherAnzahl = anzahlInt;
        APP.model.setDirty();
    }

    renderBody() {
        const arrangement = APP.arrangement;
        const options = [...Array(this.state.bodenFactory.maxCount - 1).keys()].map(value => ({
            value: value + 1,
            label: value + 1
        }));
        const types = this.state.products.map(product => ({
            value: product,
            label: product.Name,
        }));

        return (
            <div className="appear">
                {/* <fieldset>
                    <legend>{I18N("Maße")} </legend>
                    <table>
                        <tbody>
                        <tr>
                            <td>{I18N("Breite")}:</td>
                            <td>{Helper.formatToRulerUnit(this.vsData.size.x)}</td>
                        </tr>
                        <tr>
                            <td>{I18N("Tiefe")}:</td>
                            <td>{Helper.formatToRulerUnit(this.vsData.size.z)}</td>
                        </tr>
                        </tbody>
                    </table>
                </fieldset> */}

                <Select value={this.vsData.faecherAnzahl} options={options}
                        onChange={value => this.anzahlChanged(value)} label={I18N("Anzahl Böden")}/>

                {/* <Select value={this.vsData.product} options={types}
                        onChange={APP.model.tryWrap(this, value => this.vsData.setFromProduct(value))} label={I18N("Bodenstärke")}/> */}

            </div>
        )
    }
}